import { ofType, combineEpics } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import * as S from "sanctuary";
import { voidPayment } from "@/APIClient";
import {
  voidPaymentStarted,
  voidPaymentSucceeded,
  voidPaymentFailed,
  PAYMENT_MODIFICATION_PRE_AUTH_SUCCEEDED,
  PAYMENT_MODIFICATION_TYPES,
  clearVoidError,
  clearModificationPreAuthError,
  CLOSE_VOID_REFUND_MODAL,
  paymentPageAlertBarAction,
  closeVoidRefundModal,
} from "../Payment.state";
import { requestEpic } from "@/APIClient/observable.util";
import { addAlert, clearAlerts } from "@/components/alert-bar/AlertBar.state";

const clearFormEpic = (action$) =>
  action$.pipe(
    ofType(CLOSE_VOID_REFUND_MODAL),
    RxOp.mergeMap(() => Rx.of(clearVoidError(), clearModificationPreAuthError()))
  );

const voidPaymentEpic = (action$) =>
  action$.pipe(
    ofType(PAYMENT_MODIFICATION_PRE_AUTH_SUCCEEDED),
    RxOp.filter(
      ({ payload: { modificationType } }) =>
        modificationType === PAYMENT_MODIFICATION_TYPES.VOID
    ),
    RxOp.mergeMap(({ payload: { paymentId, token } }) =>
      Rx.concat([
        Rx.of(voidPaymentStarted()),
        requestEpic({
          requestMethod: voidPayment,
          requestArgs: {
            token,
            paymentId,
          },
          onSuccess: (res) =>
            Rx.of(
              voidPaymentSucceeded({ payment: res.value }),
              closeVoidRefundModal(),
              paymentPageAlertBarAction(clearAlerts()),
              paymentPageAlertBarAction(
                addAlert({
                  heading: "Transaction Voided",
                  text: `Transaction ${S.fromMaybe("")(
                    S.map(S.show)(res.value.id)
                  )} has been successfully voided.`,
                  variant: "success",
                })
              )
            ),
          onFailure: (err) =>
            Rx.of(
              voidPaymentFailed({ error: err }),
              closeVoidRefundModal(),
              paymentPageAlertBarAction(clearAlerts()),
              paymentPageAlertBarAction(
                addAlert({
                  heading: "Transaction Void Unsuccessful",
                  text: `Transaction ${paymentId} could not be voided`,
                  variant: "error",
                })
              )
            ),
        }),
      ])
    ),
    RxOp.concatAll(),
    RxOp.catchError((err) => voidPaymentFailed({ error: err.message }))
  );

const epic = combineEpics(voidPaymentEpic, clearFormEpic);

export default epic;
